import { useEffect, useState } from "react";
import { api } from "../../../Api/ApiService";
import { Menus } from "../../../components/Menu/idex";
import { Tables } from "../../../components/tables";
import {
  useDisclosure,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalFooter,
  ModalHeader,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Text,
  Grid,
  Switch,
  InputGroup,
  IconButton,
  HStack,
  useToast,
  TableContainer,
  Thead,
  Tr,
  Th,
  Table,
  Tbody,
  Td,
  Link,
  Input,
} from "@chakra-ui/react";
import { PencilSimpleLine } from "@phosphor-icons/react";
import Alert from "sweetalert2";
import { Axios, AxiosError } from "axios";
import { ModalInforComp } from "../../../components/ModalInforcomplementares";
import dayjs from "dayjs";
import { createTemporaryURL } from "../../../utils/bse64Foto";
import { StyledGrid, StyledGrid2 } from "./styles";
import { useForm } from "react-hook-form";

interface IInforTutor {
  id: string;
  nome: string;
  email: string;
  whatsapp: string;
  instagram: string;
  cpf: string;
  rg: string;
  rua: string;
  numero: number;
  bairro: string;
  cidade: string;
  uf: string;
  status: boolean;
  complementou_cadastro: boolean;
  tem_experiencia: boolean;
  tem_outro_animal: boolean;
  tipo_animais?: string[];
  quantidade_animais?: number;
}

interface IInforTable {
  col1: string;
  col2: string;
  col3: string;
  col4?: string;
  id?: string;
}

interface IAdocoes {
  adocao_id: string;
  tutor_id: string;
  nome_animal: string;
  tipo_animal: string;
  sexo_animal: string;
  url_documento: string;
  data: string;
}

interface IInputEdite {
  id_tutor: string;
  rua: string;
  numero: Number;
  bairro: string;
  cidade: string;
  uf: string;
  whatsapp: string;
  instagram: string;
}

const Tutores = () => {
  const [inforTutores, setInforTutores] = useState<IInforTutor[]>([]);
  const [tutor, setTutor] = useState<IInforTutor>();
  const [tutorResult, setTutorResult] = useState<IInforTable[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalEdite, setModalEdite] = useState(false);
  const toast = useToast();
  const [modalComplementar, setModalComplementar] = useState(false);
  const [adocoes, setAdocoes] = useState<IAdocoes[]>([]);
  const { setValue } = useForm<IInforTutor>();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset: resetForm,
  } = useForm<IInputEdite>();

  async function getTutores() {
    try {
      const resul = await api.get(
        `/tutores?token=${process.env.REACT_APP_TOKEN_API}`
      );
      setInforTutores(resul.data);

      let res: IInforTable[] = [];
      resul.data.map((item: any) => {
        res.push({
          col1: item.nome,
          col2: item.email,
          col3: item.whatsapp,
          col4: item.instagram,
          id: item.id,
        });
      });
      setTutorResult(res);
    } catch (error) {}
  }

  async function openModalTutor(id: string) {
    const tutor = await inforTutores.find((item: any) => item.id === id);
    setTutor(tutor);

    const adocoes = await api.get(
      `/adocoes/${id}?token=${process.env.REACT_APP_TOKEN_API}`
    );

    if (adocoes.data.data.length > 0) {
      let resultado: IAdocoes[] = [];
      adocoes.data.data.map((item: any) => {
        let data_create = dayjs(item.data).format("DD/MM/YYYY");
        const url = createTemporaryURL(item.documento.data);

        resultado.push({
          adocao_id: item.adocao_id,
          nome_animal: item.nome_animal,
          tipo_animal: item.tipo_animal,
          sexo_animal: item.sexo_animal,
          url_documento: url,
          tutor_id: item.tutor_id,
          data: data_create,
        });
      });

      setAdocoes(resultado);
    }

    onOpen();
  }

  async function onSubmitStatus(status: boolean) {
    try {
      if (tutor) {
        Alert.fire({
          toast: true,
          icon: "question",
          text: "Tem certeza que deseja alterar o status do tutor?",
          showCancelButton: true,
          cancelButtonText: "Não",
          cancelButtonColor: "red",
          confirmButtonText: "Sim",
          confirmButtonColor: "#044549",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const res = await api.patch(
              `/tutores?token=${process.env.REACT_APP_TOKEN_API}`,
              {
                status: status,
              },
              {
                params: {
                  id_tutor: tutor.id,
                },
              }
            );

            Alert.fire({
              toast: true,
              icon: "success",
              text: res.data.message,
              confirmButtonText: "OK",
              confirmButtonColor: "#3f3d56",
            }).then(() => {
              window.location.reload();
            });
          }
        });
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  async function onSubmitEdite(data: IInputEdite) {
    try {
      if (tutor) {
        data.numero = Number(data.numero);

        Alert.fire({
          toast: true,
          icon: "question",
          text: "Tem certeza que deseja alterar os dados do tutor?",
          showCancelButton: true,
          cancelButtonText: "Não",
          cancelButtonColor: "red",
          confirmButtonText: "Sim",
          confirmButtonColor: "#044549",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const res = await api.patch(
              `/tutores?token=${process.env.REACT_APP_TOKEN_API}`,
              {
                ...data,
              },
              {
                params: {
                  id_tutor: tutor.id,
                },
              }
            );
            Alert.fire({
              toast: true,
              icon: "success",
              text: res.data.message,
              confirmButtonText: "OK",
              confirmButtonColor: "#3f3d56",
            }).then(() => {
              window.location.reload();
            });
          }
        });
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  const handleOpenModal = () => {
    setModalComplementar(true);
  };

  const handleCloseModal = () => {
    setModalComplementar(false);
  };

  useEffect(() => {
    getTutores();
  }, []);

  return (
    <>
      <Menus />
      <Tables
        title={"TUTORES CADASTRADOS"}
        header1={"Tutor"}
        header2={"Email"}
        header3={"WhatsApp"}
        header4={"Instagram"}
        body={tutorResult}
        status={"2"}
        callback={openModalTutor}
      />
      {tutor ? (
        <Modal
          closeOnOverlayClick={false}
          isOpen={isOpen}
          onClose={onClose}
          size={"6xl"}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader textAlign={"center"} color={"#2F2E41"} fontSize={30}>
              {tutor.nome}
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody>
              <FormControl display={"flex"} flexDir={"column"} gap={20}>
                <FormControl>
                  <FormControl
                    display={"flex"}
                    justifyContent={"space-between"}
                  >
                    <FormLabel
                      fontSize={25}
                      color={"#3F3D56"}
                      fontWeight={"bold"}
                    >
                      DADOS PESSOAIS
                    </FormLabel>

                    <HStack>
                      <InputGroup>
                        <FormLabel fontSize={25} color={"#3F3D56"}>
                          Ativo:
                        </FormLabel>
                        <Switch
                          colorScheme={"teal"}
                          size={"lg"}
                          mt={1}
                          defaultChecked={tutor.status}
                          onChange={(e) => onSubmitStatus(e.target.checked)}
                        />
                        <IconButton
                          aria-label="teste"
                          ml={"1rem"}
                          icon={<PencilSimpleLine />}
                          onClick={() => setModalEdite(true)}
                        />
                      </InputGroup>
                    </HStack>
                  </FormControl>

                  <StyledGrid
                    gridTemplateColumns={"auto auto auto auto"}
                    w={"100%"}
                    minH={"150px"}
                    padding={3}
                    gridGap={4}
                    border={"1px solid #3F3D56"}
                    borderRadius={"20px"}
                  >
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>Nome:</Text>
                      <Text>{tutor.nome}</Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>CPF:</Text>
                      <Text>{tutor.cpf}</Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>RG / CNH:</Text>
                      <Text>{tutor.rg}</Text>
                    </FormControl>
                    <InputGroup gap={4} fontSize={18} w={"170px"}>
                      <Text fontWeight={"bold"}>Rua:</Text>
                      <Text>{tutor.rua}</Text>
                    </InputGroup>
                    <InputGroup gap={4} fontSize={18}>
                      <Text fontWeight={"bold"}>Nº:</Text>
                      <Text>{tutor.numero}</Text>
                    </InputGroup>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>Bairro:</Text>
                      <Text>{tutor.bairro}</Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>Cidade:</Text>
                      <Text>{tutor.cidade}</Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>UF:</Text>
                      <Text>{tutor.uf}</Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>Email:</Text>
                      <Text>{tutor.email}</Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>WhatsApp:</Text>
                      <Text>{tutor.whatsapp}</Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                    >
                      <Text fontWeight={"bold"}>Instagram:</Text>
                      <Text>{tutor.instagram}</Text>
                    </FormControl>
                  </StyledGrid>
                </FormControl>
                <FormControl>
                  <FormControl
                    display={"flex"}
                    justifyContent={"space-between"}
                  >
                    <FormLabel
                      fontSize={25}
                      color={"#3F3D56"}
                      fontWeight={"bold"}
                    >
                      INFORMAÇÕES COMPLEMENTARES
                    </FormLabel>
                    <IconButton
                      aria-label="teste"
                      icon={<PencilSimpleLine />}
                      onClick={handleOpenModal}
                    />
                  </FormControl>
                  <StyledGrid2
                    gridTemplateColumns={" auto auto"}
                    w={"100%"}
                    padding={3}
                    gridGap={4}
                    border={"1px solid #3F3D56"}
                    borderRadius={"20px"}
                  >
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                      w={"320px"}
                    >
                      <Text fontWeight={"bold"}>
                        Tem experiência com animais?
                      </Text>
                      <Text>
                        {tutor.complementou_cadastro
                          ? tutor.tem_experiencia
                            ? "Sim"
                            : "Não"
                          : ""}
                      </Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                      w={"320px"}
                    >
                      <Text fontWeight={"bold"}>
                        Tem outros animais em casa?
                      </Text>
                      <Text>
                        {tutor.complementou_cadastro
                          ? tutor.tem_outro_animal
                            ? "Sim"
                            : "Não"
                          : ""}
                      </Text>
                    </FormControl>

                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                      w={"320px"}
                    >
                      <Text fontWeight={"bold"}>Tipo(s) animai(s):</Text>
                      <Text>
                        {tutor.complementou_cadastro
                          ? tutor.tem_outro_animal
                            ? tutor.tipo_animais
                            : "Não é tutor de animais"
                          : ""}
                      </Text>
                    </FormControl>
                    <FormControl
                      display={"flex"}
                      flexDir={"row"}
                      gap={4}
                      fontSize={18}
                      w={"320px"}
                    >
                      <Text fontWeight={"bold"}>
                        Quantidade de animais em casa:
                      </Text>
                      <Text>
                        {tutor.complementou_cadastro
                          ? tutor.tem_outro_animal
                            ? tutor.quantidade_animais
                            : 0
                          : ""}
                      </Text>
                    </FormControl>
                  </StyledGrid2>
                </FormControl>

                {adocoes.length > 0 ? (
                  <>
                    <FormControl>
                      <FormControl
                        display={"flex"}
                        justifyContent={"space-between"}
                      >
                        <FormLabel
                          fontSize={25}
                          color={"#3F3D56"}
                          fontWeight={"bold"}
                        >
                          ADOÇÕES
                        </FormLabel>
                      </FormControl>
                      <TableContainer
                        border={"1px solid #CCCCCC"}
                        borderRadius={10}
                      >
                        <Table variant={"simple"} size={"sm"}>
                          <Thead>
                            <Tr bg={"#CCCCCC"} color={"#3F3D56"}>
                              <Th fontSize={18} color={"#3F3D56"}>
                                Nome do animal
                              </Th>
                              <Th fontSize={18} color={"#3F3D56"}>
                                Tipo do animal
                              </Th>
                              <Th fontSize={18} color={"#3F3D56"}>
                                sexo do animal
                              </Th>
                              <Th fontSize={18} color={"#3F3D56"}>
                                Documento
                              </Th>
                              <Th fontSize={18} color={"#3F3D56"}>
                                Data de adoção
                              </Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            <>
                              {adocoes.map((adocao: any) => (
                                <Tr>
                                  <Td fontSize={18}>{adocao.nome_animal}</Td>
                                  <Td fontSize={18}>{adocao.tipo_animal}</Td>
                                  <Td fontSize={18}>{adocao.sexo_animal}</Td>
                                  <Td fontSize={18}>
                                    <Link
                                      href={adocao.url_documento}
                                      target={"_blank"}
                                    >
                                      <Button
                                        h={"auto"}
                                        pt={1}
                                        pb={1.5}
                                        bg={"#3f3d56"}
                                        color={"#ffffff"}
                                        _hover={{
                                          backgroundColor: "#343341",
                                        }}
                                      >
                                        Abrir
                                      </Button>
                                    </Link>
                                  </Td>
                                  <Td>{adocao.data}</Td>
                                </Tr>
                              ))}
                            </>
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </FormControl>
                  </>
                ) : (
                  <></>
                )}
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button
                border={"1px solid #c03333"}
                variant={"outline"}
                color={"#c03333"}
                _hover={{ backgroundColor: "#c03333", color: "#ffffff" }}
                onClick={() => {
                  onClose();
                  setModalComplementar(false);
                  setAdocoes([]);
                }}
              >
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      ) : (
        <></>
      )}

      {modalComplementar && tutor ? (
        <>
          <ModalInforComp
            tutor_id={tutor.id}
            onClose={handleCloseModal}
            isOpen={modalComplementar}
          />
        </>
      ) : (
        <></>
      )}

      <Modal closeOnOverlayClick={false} isOpen={modalEdite} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            color={"#3F3D56"}
            fontWeight={"bold"}
            fontSize={25}
            textAlign={"center"}
          >
            Editar informações do tutor
          </ModalHeader>
          <form onSubmit={handleSubmit(onSubmitEdite)}>
            <ModalBody pb={6}>
              <FormControl>
                <InputGroup gap={12}>
                  <FormLabel>Rua:</FormLabel>
                  <Input
                    type="text"
                    size={"sm"}
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    borderRadius={"5px"}
                    defaultValue={tutor?.rua}
                    {...register("rua", { required: "Campo obrigatório!" })}
                  />
                </InputGroup>
                {errors.rua && (
                  <Text ml={"5.6rem"} mt={0} fontSize={11} color={"#c03333"}>
                    {errors.rua.message}
                  </Text>
                )}
              </FormControl>

              <FormControl mt={4}>
                <InputGroup>
                  <HStack mr={4} gap={14}>
                    <FormLabel>N°:</FormLabel>
                    <Input
                      type="number"
                      size={"sm"}
                      variant={"filled"}
                      border={"1px solid #B0BEC5"}
                      borderRadius={"5px"}
                      defaultValue={tutor?.numero}
                      {...register("numero", {
                        required: "Campo obrigatório!",
                      })}
                    />
                  </HStack>

                  <HStack>
                    <FormLabel>UF:</FormLabel>
                    <Input
                      type="text"
                      size={"sm"}
                      variant={"filled"}
                      border={"1px solid #B0BEC5"}
                      borderRadius={"5px"}
                      defaultValue={tutor?.uf}
                      {...register("uf", { required: "Campo Obrigatório" })}
                    />
                  </HStack>
                </InputGroup>
                <InputGroup>
                  {errors.numero && (
                    <Text ml={"5.6rem"} mt={0} fontSize={11} color={"#c03333"}>
                      {errors.numero.message}
                    </Text>
                  )}
                  {errors.uf && (
                    <Text ml={"5.6rem"} mt={0} fontSize={11} color={"#c03333"}>
                      {errors.uf.message}
                    </Text>
                  )}
                </InputGroup>
              </FormControl>

              <FormControl mt={4}>
                <InputGroup gap={6}>
                  <FormLabel>Cidade:</FormLabel>
                  <Input
                    size={"sm"}
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    borderRadius={"5px"}
                    defaultValue={tutor?.cidade}
                    {...register("cidade", { required: "Campo Obrigatório!" })}
                  />
                </InputGroup>
                {errors.cidade && (
                  <Text ml={"5.6rem"} mt={0} fontSize={11} color={"#c03333"}>
                    {errors.cidade.message}
                  </Text>
                )}
              </FormControl>

              <FormControl mt={4}>
                <InputGroup gap={8}>
                  <FormLabel>Bairro:</FormLabel>
                  <Input
                    type="text"
                    size={"sm"}
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    borderRadius={"5px"}
                    defaultValue={tutor?.bairro}
                    {...register("bairro", { required: "Campo Obrigatório!" })}
                  />
                </InputGroup>
                {errors.bairro && (
                  <Text ml={"5.6rem"} mt={0} fontSize={11} color={"#c03333"}>
                    {errors.bairro.message}
                  </Text>
                )}
              </FormControl>

              <FormControl mt={4}>
                <InputGroup>
                  <FormLabel>WhatsApp:</FormLabel>
                  <Input
                    size={"sm"}
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    borderRadius={"5px"}
                    defaultValue={tutor?.whatsapp}
                    {...register("whatsapp", {
                      required: "Campo Obrigatório!",
                    })}
                  />
                </InputGroup>
                {errors.whatsapp && (
                  <Text ml={"5.6rem"} mt={0} fontSize={11} color={"#c03333"}>
                    {errors.whatsapp.message}
                  </Text>
                )}
              </FormControl>

              <FormControl mt={4}>
                <InputGroup gap={1}>
                  <FormLabel>Instagram:</FormLabel>
                  <Input
                    type="text"
                    size={"sm"}
                    variant={"filled"}
                    border={"1px solid #B0BEC5"}
                    borderRadius={"5px"}
                    defaultValue={tutor?.instagram}
                    {...register("instagram")}
                  />
                </InputGroup>
              </FormControl>
            </ModalBody>

            <ModalFooter justifyContent={"center"}>
              <Button
                w={40}
                h={8}
                border={"1px solid #c03333"}
                color={"#c03333"}
                fontWeight={"medium"}
                backgroundColor={"white"}
                marginRight={"5"}
                onClick={() => {
                  setModalEdite(false);
                  resetForm();
                }}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                w={40}
                h={8}
                border={"1px solid #044549"}
                color={"#044549"}
                backgroundColor={"white"}
                fontWeight={"medium"}
              >
                Salvar
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};

export { Tutores };
